import { Modal } from '@design-system/components/modal/modal';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './DisconnectConfirmationModal.css';

type Props = {
  isOpen: boolean;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DisconnectConfirmationModal = ({
  isOpen,
  email,
  onConfirm,
  onCancel,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title="Disconnect account"
    centerContent
  >
    <Typography variant="body" size="large" color="B-100" fontWeight="normal">
      You&apos;ll log in with your email instead: {email}.
      <br />
      You can reconnect anytime.
    </Typography>
    <div className={styles.buttons}>
      <Button variant="text" color="neutral" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant="filled"
        color="neutral"
        onClick={onConfirm}
        className={styles.disconnectButton}
      >
        Disconnect
      </Button>
    </div>
  </Modal>
);
